// Companion asks for manufacturing, ops, logistics, and platform catalog tours.
// Kept separate so pilotAskArtifacts.ts stays under the file-size soft band.

import type { FireflyAskArtifact } from "./tourTypes";

export const FIREFLY_ASK_PILOT_ARTIFACTS_OPS_MFG: readonly FireflyAskArtifact[] = [
  {
    id: "ask-mfg-inventory",
    companionTourId: "tour-mfg-inventory",
    intents: [
      "how do i enter material costs",
      "how do i update wac",
      "how do i post a material receive",
    ],
    bucketRelevance: ["manufacturing"],
    requiredRoles: ["manufacturing", "platform_owner", "platform_admin", "platform_dev"],
    answer:
      "Manufacturing Inventory lists materials with on-hand and WAC. Post receive lines with qty and unit cost — WAC recalculates on post; there is no inline WAC edit field.",
    navigateTo: { mode: "mfgInventory", ctaLabel: "Open Inventory" },
    highlightTarget: "mfg-receive-lines",
  },
  {
    id: "ask-mfg-plants-units",
    companionTourId: "tour-mfg-plants-units",
    intents: [
      "how do i see where units are built",
      "how do i manage plants",
      "where is the units list",
    ],
    bucketRelevance: ["manufacturing"],
    requiredRoles: ["manufacturing", "platform_owner", "platform_admin", "platform_dev"],
    answer:
      "Manufacturing → Plants lists production sites and dealer attachments. Units shows each shed's plant and build timeline (created → started → complete).",
    navigateTo: { mode: "mfgPlants", ctaLabel: "Open Plants" },
    highlightTarget: "mfg-plants-list",
  },
  {
    id: "ask-ops-paperwork",
    companionTourId: "tour-ops-paperwork",
    intents: [
      "how do i check deal paperwork",
      "how do i find missing paperwork",
      "where is the deal checklist",
    ],
    bucketRelevance: ["ops"],
    requiredRoles: [
      "ops_reviewer",
      "admin",
      "owner",
      "org_admin",
      "org_owner",
      "trainer",
    ],
    answer:
      "Ops → Deals lists live deals and per-deal paperwork checklists. The header clipboard count is overdue items; open a deal to update missing → received / verified.",
    navigateTo: { mode: "operations", ctaLabel: "Open Deals" },
    highlightTarget: "ops-deals-list",
  },
  {
    id: "ask-rto-terms",
    companionTourId: "tour-rto-terms",
    intents: [
      "how do i configure rto terms",
      "how do i set rent to own terms",
      "where are sales console rto terms",
    ],
    bucketRelevance: ["ops"],
    requiredRoles: ["admin", "owner", "org_admin", "org_owner"],
    answer:
      "Ops → RTO Terms defines the term rows Sales Console uses. Optionally inherit manufacturer terms, or edit org rows (months, divisor, down) and Save RTO terms.",
    navigateTo: { mode: "rtoTerms", ctaLabel: "Open RTO Terms" },
    highlightTarget: "rto-terms-table",
  },
  {
    id: "ask-logistics-routes",
    companionTourId: "tour-logistics-routes",
    intents: [
      "how do i dispatch a route",
      "how do i fix a stop address",
      "where is the delivery queue",
    ],
    bucketRelevance: ["logistics"],
    requiredRoles: [
      "logistics_coordinator",
      "dispatcher",
      "manufacturing",
      "admin",
      "owner",
      "org_admin",
      "org_owner",
    ],
    answer:
      "Logistics → Routes shows the delivery queue and dispatch board. Open a route for the stops timeline (edit address on a stop); drag a planned route onto a rig to assign carrier + driver.",
    navigateTo: { mode: "logisticsRoutes", ctaLabel: "Open Routes" },
    highlightTarget: "logi-routes-list",
  },
  {
    id: "ask-logistics-carriers",
    companionTourId: "tour-logistics-carriers",
    intents: [
      "how do i add a hauler",
      "how do i deactivate a carrier",
      "where do i manage carriers",
    ],
    bucketRelevance: ["logistics"],
    requiredRoles: [
      "logistics_coordinator",
      "dispatcher",
      "manufacturing",
      "admin",
      "owner",
      "org_admin",
      "org_owner",
    ],
    answer:
      "Logistics → Carriers is the hauler roster. Use + New carrier to add one; Deactivate hides a hauler from new Routes assignments without breaking history.",
    navigateTo: { mode: "logisticsCarriers", ctaLabel: "Open Carriers" },
    highlightTarget: "logi-carriers-form",
  },
  {
    id: "ask-platform-home",
    companionTourId: "tour-platform-home",
    intents: [
      "how do i impersonate a role",
      "where is platform context",
      "how does the dev simulator work",
    ],
    bucketRelevance: ["platform"],
    requiredRoles: [
      "platform_owner",
      "platform_admin",
      "platform_dev",
      "platform_trainer",
    ],
    answer:
      "Platform View is cross-org support chrome. The Activity dock Platform context card shows your role, scoped org, and impersonation mask. platform_dev opens Dev simulator in the sidebar to Apply browser-only role/viewport overlays — JWT/RLS still use your real identity.",
    navigateTo: { mode: "platform", ctaLabel: "Open Platform" },
    highlightTarget: "platform-context",
  },
];
